
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/package-details/[slug]",
      function () {
        return require("private-next-pages/package-details/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/package-details/[slug]"])
      });
    }
  